import React, { useState, useRef } from 'react'
import { motion } from 'framer-motion'
import emailjs from '@emailjs/browser'

import Magazines from '../../Magazines/Magazines'
import { slideIn } from '../../utils/motion'
import EarthCanvas from './EarthCanvas'

const Footer = () => {
  const formRef = useRef()
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  })

  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { target } = e
    const { name, value } = target

    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    emailjs
      .send(
        process.env.EMAIL_SERVICE_ID,
        process.env.EMAIL_TEMPLATE_ID,
        {
          from_name: form.name,
          to_name: 'Asogwa Christsanctus Chinedu',
          from_email: form.email,
          to_email: 'chineduchristsanctus020@gmail.com',
          message: form.message,
        },
        process.env.EMAIL_PROJECT_ID
      )
      .then(
        () => {
          setLoading(false)
          alert('Thank you. I will get back to you as soon as possible.')

          setForm({
            name: '',
            email: '',
            message: '',
          })
        },
        (error) => {
          setLoading(false)
          console.error(error)

          alert('Ahh, something went wrong. Please try again.')
        }
      )
  }

  return (
    <section className='xl:mt-12 flex-col-reverse xl:flex-row flex gap-8 overflow-hidden mb-10 '>
      <motion.div
        variants={slideIn('left', 'tween', 0.2, 1)}
        className='dark:bg-black_100 py-8 px-6 rounded-2xl shadow-lg dark:shadow-none bg-white mx-auto w-full m560:w-[520px]'
      >
        <p className='sm:text-[18px] text-[14px] dark:text-secondary tracking-wider uppercase font-medium text-primary'>
          Get in touch
        </p>
        <h2 className='text-[#915eff] dark:text-white font-black md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
          Contact.
        </h2>
        <form
          className='mt-12 flex flex-col gap-8'
          ref={formRef}
          onSubmit={handleSubmit}
        >
          <label htmlFor='' className='flex flex-col'>
            <span className='dark:text-white font-medium mb-4 text-primary'>
              Your Name
            </span>
            <input
              onChange={(e) => handleChange(e)}
              type='text'
              name='name'
              value={form.name}
              placeholder="What's your name?"
              className=' outline-none py-4 px-6 dark:text-white rounded-lg border-none font-medium bg-primary_color dark:bg-tertiary shadow-md dark:shadow-none placeholder:text-gray-500 dark:placeholder:text-secondary'
            />
          </label>
          <label htmlFor='' className='flex flex-col'>
            <span className='dark:text-white font-medium mb-4 text-primary'>
              Your Email
            </span>
            <input
              onChange={(e) => handleChange(e)}
              type='text'
              name='email'
              value={form.email}
              placeholder="What's your email?"
              className='bg-primary_color dark:bg-tertiary shadow-md dark:shadow-none placeholder:text-gray-500 dark:placeholder:text-secondary outline-none py-4 px-6  dark:text-white rounded-lg border-none font-medium'
            />
          </label>
          <label htmlFor='' className='flex flex-col'>
            <span className='dark:text-white font-medium mb-4 text-primary'>
              Your Message
            </span>
            <textarea
              rows='7'
              type='text'
              name='message'
              value={form.message}
              onChange={(e) => handleChange(e)}
              placeholder='What do you wand to say?'
              className='bg-primary_color dark:bg-tertiary shadow-md dark:shadow-none placeholder:text-gray-500 dark:placeholder:text-secondary outline-none py-4 px-6  dark:text-white rounded-lg border-none font-medium resize-none'
            />
          </label>
          <button
            className='bg-primary_color dark:bg-tertiary shadow-md text-gray-500 py-3 px-8 outline-none w-fit dark:text-white font-bold  shadow-primary rounded-xl
          '
            type='submit'
          >
            {loading ? 'Sending ' : 'Send'}
          </button>
        </form>
      </motion.div>

      <motion.div
        variants={slideIn('right', 'tween', 0.2, 1)}
        className='xl:flex-1 xl:h-auto md:h-[550px] h-[350px]  mx-auto w-full m560:w-[540px]'
      >
        <EarthCanvas />
      </motion.div>
    </section>
  )
}

export default Magazines(Footer, 'contact')
